module.exports = __webpack_public_path__ + "media/images/Telugu-matrimony-banner-5cfc476e2a602a53fbae56112f7b634d.jpg";